import React, { useMemo } from 'react';
import ElementSettingsOption from './element-settings-option';
import buildDividerOption from '../helpers/build-divider-option';

const OPTIONS_WITHOUT_DIVIDER = ['columns-amount', 'column-width'];

function ElementSettingsOptions({ item, settingId }) {
  const { options } = item;

  const optsWithDivider = useMemo(
    () =>
      options.reduce((res, option, index) => {
        res.push(option);

        if (index < options.length - 1 && !OPTIONS_WITHOUT_DIVIDER.includes(option.id)) {
          const dividerOption = buildDividerOption(index);
          res.push(dividerOption);
        }

        return res;
      }, []),
    [options]
  );

  return optsWithDivider.map((option) => (
    <ElementSettingsOption key={option.id} option={option} settingId={settingId} />
  ));
}

export default ElementSettingsOptions;
